export const loadFonts = () => document.fonts.ready
